import { ChangePassword, Modal, useSession } from '@adiox/ui';

/**
 * When the broker asked for a new password at the next sign-in, the terminal asks for it before anything else; changing it
 * signs the client out, and they sign in again with the new one.
 */
export function NewPasswordRequired() {
  const user = useSession().user;
  const required = user?.mustChangePassword === true && user.readOnly !== true;
  return (
    <Modal open={required} title="Choose a new password" onClose={() => undefined}>
      {required && (
        <div className="flex flex-col gap-3">
          <p className="text-sm">Your broker asks you to choose a new password before you go on.</p>
          <ChangePassword />
        </div>
      )}
    </Modal>
  );
}
